export function getBrowserPlatform(): 'android' | 'ios' | 'other' {
	if (typeof navigator === 'undefined') {
		return 'other';
	}

	const userAgent = navigator.userAgent.toLowerCase();

	if (/iphone|ipad|ipod/.test(userAgent)) {
		return 'ios';
	}

	if (/android/.test(userAgent)) {
		return 'android';
	}

	return 'other';
}
